
import { getViewUiData } from './api.js'

import view from './user/view.js'
import events from './events.js'
import notifications from './notifications.js'

const _uiData = {
  district: {},
  vendor: {},
  partition: {},
  schoolYear: {},
}

function loadDistrict(districtCode, uiDataObj) {
  _uiData.district[districtCode] = uiDataObj
}

function loadVendor(vendorId, uiDataObj) {
  _uiData.vendor[vendorId] = uiDataObj
}

function loadPartition(partitionId, uiDataObj) {
  _uiData.partition[partitionId] = uiDataObj
}

function loadSchoolYear(schoolYearCode, uiDataObj) {
  _uiData.schoolYear[schoolYearCode] = uiDataObj
}

function using(section, callback) {
  callback(_uiData[section])
}

function clear(section) {
  _uiData[section] = {}
}

function loadAllData(data) {
  if (data.district !== undefined) {
    for (const districtCode in data.district) {
      loadDistrict(districtCode, data.district[districtCode])
    }
  }
  if (data.vendor !== undefined) {
    for (const vendorId in data.vendor) {
      loadVendor(vendorId, data.vendor[vendorId])
    }
  }
  if (data.partition !== undefined) {
    for (const partitionId in data.partition) {
      loadPartition(partitionId, data.partition[partitionId])
    }
  }
  if (data.schoolYear !== undefined) {
    for (const schoolYearCode in data.schoolYear) {
      loadSchoolYear(schoolYearCode, data.schoolYear[schoolYearCode])
    }
  }
}

events.register('viewUpdated', async () => {
  let _view = await view.get()

  let data = undefined
  try {
    data = (await getViewUiData(_view.getRef())).data
  }
  catch (error) {
    notifications.pushError(`Error getting UI data for view: ${error}`, error)
    return
  }

  loadAllData(data)

  events.trigger('uiDataUpdated')
})

export default {
  loadAllData,
  loadDistrict,
  loadVendor,
  loadPartition,
  loadSchoolYear,
  using,
  clear,
}
